export class WebApiRequestBase {
    token: string;
};

export class WebApiRequest<T> extends WebApiRequestBase {
    data: T;
};


// WEBPACK FOOTER //
// ./src/angular_library/models/web-api-request.ts